var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
export var Compare = function (_a) {
    var color = _a.color, size = _a.size;
    return (_jsx("svg", __assign({ width: size, height: size, viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: _jsx("path", { d: "M8.33333 19.1666V17.4999H4.16667C3.70833 17.4999 3.31597 17.3367 2.98958 17.0103C2.66319 16.6839 2.5 16.2916 2.5 15.8333V4.16658C2.5 3.70825 2.66319 3.31589 2.98958 2.9895C3.31597 2.66311 3.70833 2.49992 4.16667 2.49992H8.33333V0.833252H10V19.1666H8.33333ZM4.16667 14.9999H8.33333V9.99992L4.16667 14.9999ZM11.6667 17.4999V9.99992L15.8333 14.9999V4.16658H11.6667V2.49992H15.8333C16.2917 2.49992 16.684 2.66311 17.0104 2.9895C17.3368 3.31589 17.5 3.70825 17.5 4.16658V15.8333C17.5 16.2916 17.3368 16.6839 17.0104 17.0103C16.684 17.3367 16.2917 17.4999 15.8333 17.4999H11.6667Z", fill: color }) })));
};
